<template>
    <div id="chatai_index" class="page_container">
        <div class="page_body_wrapper">
            <div class="page_body">
                <div :class="['page_aside',{'hide':!sldeShow}, site_skin]">
                    <div @click="sldeShow=!sldeShow" :class="['collapse_icon',sldeShow?'fold':'unfold']"></div>
                    <div :class="['aside_wrap',{'overhiden':!sldeShow}]">
                        <div class="slide-top" @click="addDialog">+ 新建绘画</div>
                        <div class="slide-list">
                            <div class="dialog-list" v-if="dialog_list.length">
                                <div @click="selectDialog(dia.id)" :class="['dialog-item',{'active':dialogId==dia.id}]" v-for="(dia,index) in dialog_list" :key="index">
                                    <div class="dialog-msg-icon dialog-icon"></div>
                                    <div class="dialog-msg-text"><input :ref="'titleInput'+index" @blur="saveDialog(dia)" class="dialog-msg-input" v-if="dia.editFlag" type="text" v-model="dia.title"><span v-else>{{ dia.title }}</span></div>
                                    <div v-show="dialogId==dia.id" @click.stop="editDialog(dia,index)" class="dialog-edit-icon dialog-icon"></div>
                                    <div @click.stop="delDialog(dia, index)" class="dialog-del-icon dialog-icon"></div>
                                </div>
                            </div>
                            <div class="empty-dialog" v-else>
                                <div class="empty-icon"></div>
                                <div class="empty-text">暂无绘画</div>
                            </div>
                        </div>
                        <div class="slide-bottom">
                            <div class="slide-btn" @click="clearDialog">
                                <img class="slide-btn-icon" :src="'/static/skin/'+site_skin+'/clear_icon.png'" />
                                <div class="slide-btn-text">清除记录</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="page_content" id="eventWrapper">
                    <div class="content_body" ref="scrollWrap">
                        <div class="show_banner" v-if="currentDialog.length == 0">
                            <div class="banner_title">全网独家技术研发，MidJourney官方API接口</div>
                            <div class="banner_tips">点击插入下方精选提示词或自行输入文字即可绘图</div>
                            <div class="banner_content">
                                <div class="recommend_label">
                                    <div class="label_text">精选推荐</div>
                                    <div class="label_line"></div>
                                    <div class="label_btn" @click="fetchIndex"><img src="./img/refresh.png" alt=""><span>换一批</span></div>
                                </div>
                                <div class="banner_img_list">
                                    <div class="cell_item" v-for="(rec, index) in recomend_img_list" :key="index">
                                        <div class="cell_content">
                                            <img class="cell_img" @click="previewImg(rec.img_url+'?width=700&height=700')" :src="rec.img_url+'?width=360&height=360'" alt="加载错误" />
                                            <div class="img_info">
                                                <div class="info_item">
                                                    <img class="info_icon" src="../components/img/person-time.png" />
                                                    <span>{{ rec.use_num }}</span>
                                                </div>
                                                <div class="info_item" @click="inputVal=rec.prompt" >
                                                    <img class="info_icon" src="../components/img/tips_icon.png" />
                                                    <span class="tips">插入提示词</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="msg-wrap" ref="msgWrap" v-else>
                            <div class="msg-item" v-for="(msg,index) in currentDialog" :key="index">
                                <div class="msg-content right">
                                    <img class="user-img" :src="userInfo.avatarurl?userInfo.avatarurl:'/static/img/my_avatar.png'" />
                                    <div class="content-item">
                                        <!-- <div class="copy-item" v-if="msg.img_type=='img_c'">
                                            <img @click="copytext(msg.prompt)" class="copy-icon" src="./img/copy_icon.png" />
                                        </div> -->
                                        <div>
                                            <div class="msg-userinfo"><span>{{ msg.add_time }}</span>{{ userInfo.nickname }}</div>
                                            <div v-if="msg.img_type=='img_c'" class="msg-text" v-html="msg.prompt"></div>
                                            <div v-if="msg.img_type=='img_u'" class="msg-text" v-html="'U'+msg.img_index"></div>
                                            <div v-if="msg.img_type=='img_v'" class="msg-text" v-html="'V'+msg.img_index"></div>
                                        </div>
                                    </div>
                                </div>
                                <div class="msg-content left">
                                    <img class="user-img" src="./img/mj_avatar.webp" />
                                    <div class='content-item'>
                                        <div>
                                            <div class="msg-userinfo2">MidJourney<span>{{ msg.add_time }}</span></div>
                                            <div class="msg-text">
                                                <div class="item_prompt">{{ msg.prompt }}</div>
                                                <div class="create_error" v-if="msg.status == 3">
                                                    <div class="remove_icon" @click="delMsg(msg.draw_id,index)"></div>
                                                    <img class="error_icon" src="./img/image_error.png" alt="">
                                                    <div class="error_text">很遗憾，绘画失败 !</div>
                                                    <div class="error_btn" @click="showDefeatPopup">查看失败原因</div>
                                                </div>
                                                <div class="detail_loading msg-item-content" v-else-if="!msg.img_url && msg.status < 2">
                                                    <div class="remove_icon" @click="delMsg(msg.draw_id,index)"></div>
                                                    <circleloading></circleloading>
                                                    <div class="loading_text">绘画生成中，请稍后...</div>
                                                </div>
                                                <div v-else class="msg-item-content">
                                                    <div class="msg_img_wrap">
                                                        <!-- <img class="msg_img_ele" @click="previewImg(msg.img_url+'?width=700&height=700')" :src="msg.img_url+'?width=500&height=500'" alt=""> -->
                                                            <el-image style="display:block;"
                                                                :src="msg.img_url+'?width=700&height=700'" 
                                                                :preview-src-list="[msg.img_url+'?width=700&height=700']">
                                                            </el-image>
                                                            <div class="img_footer">
                                                            <div class="footer_item">
                                                                <a target="_blank" :href="msg.raw_img_url"><span class="footer_icon download"></span><span>下载</span></a>
                                                            </div>
                                                            <div class="footer_item" @click="previewImg(msg.img_url+'?width=700&height=700')">
                                                                <span class="footer_icon preview"></span><span>预览</span>
                                                            </div>
                                                            <div class="footer_item" @click="delMsg(msg.draw_id,index)">
                                                                <span class="footer_icon delete"></span><span>删除</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="creating_progress" v-if="msg.status < 2">
                                                        <div class="progress_bar"><div class="progress_line" :style="{'width':msg.progress+'%'}"></div></div><div class="progress_percent">{{msg.progress}}%</div>
                                                    </div>
                                                    <template v-if="msg.img_type!='img_u'&&msg.status==2">
                                                        <div class="btn_group">
                                                            <div @click="detailImg('u',i,msg,u)" :class="['btn',{'disabled':u==1},{'loading':u==2}]" v-for="(u,i) in msg.u_code" :key="i"><svg v-if="u==2" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" t="1688018410651" class="icon" viewBox="0 0 1024 1024" version="1.1" p-id="4388" width="16" height="16"><path d="M512 907c-24.852 0-45-20.148-45-45s20.148-45 45-45c168.446 0 305-136.554 305-305S680.446 207 512 207 207 343.554 207 512c0 24.852-20.148 45-45 45S117 536.852 117 512c0-218.152 176.848-395 395-395S907 293.848 907 512 730.152 907 512 907z" fill="#18a058" p-id="4389"/></svg>U{{i+1}}</div>
                                                            <div @click="detailImgRedraw(msg)" :class="['btn', 'redraw',{'loading':msg.loading==1}]"><svg v-if="msg.loading==1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" t="1688018410651" class="icon" viewBox="0 0 1024 1024" version="1.1" p-id="4388" width="16" height="16"><path d="M512 907c-24.852 0-45-20.148-45-45s20.148-45 45-45c168.446 0 305-136.554 305-305S680.446 207 512 207 207 343.554 207 512c0 24.852-20.148 45-45 45S117 536.852 117 512c0-218.152 176.848-395 395-395S907 293.848 907 512 730.152 907 512 907z" fill="#18a058" p-id="4389"/></svg><img src="./img/mj_icon_redraw.png"/></div>
                                                        </div>
                                                        <div class="btn_group">
                                                            <div @click="detailImg('v',i,msg,v)" :class="['btn',{'disabled':v==1},{'loading':v==2}]" v-for="(v,i) in msg.v_code" :key="i"><svg v-if="v==2" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" t="1688018410651" class="icon" viewBox="0 0 1024 1024" version="1.1" p-id="4388" width="16" height="16"><path d="M512 907c-24.852 0-45-20.148-45-45s20.148-45 45-45c168.446 0 305-136.554 305-305S680.446 207 512 207 207 343.554 207 512c0 24.852-20.148 45-45 45S117 536.852 117 512c0-218.152 176.848-395 395-395S907 293.848 907 512 730.152 907 512 907z" fill="#18a058" p-id="4389"/></svg>V{{i+1}}</div>
                                                                <el-tooltip placement="top">
                                                                    <div class="draw_tips" slot="content" style="line-height:1.5;">
                                                                        U 是 Upscale 的缩写，对结果满意，可画出更清晰的大图！<br/>
                                                                        V 是 Variation 的缩写，以这张图作延伸再次生成类似图片！<br/>
                                                                        数字1-2-3-4分别代表的是「左上、右上、左下、右下」图片位置！
                                                                    </div>
                                                                    <div class="redraw2 btn"><img src="./img/mj_explain.png"/></div>
                                                                </el-tooltip>
                                                        </div>
                                                    </template>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="content_footer">
                        <div :class="['footer_wrap', site_skin]">
                            <el-popover
                                placement="top"
                                width="450"
                                @hide="hidePopover"
                                trigger="click">
                                <div class="upload_img_wrapper">
                                    <div class="upload_area">
                                        <img class="upload_icon" src="./img/img_icon.png" alt="">
                                        <div class="upload_text">点击或者拖动文件到该区域来上传</div>
                                        <div class="upload_label">请上传10M以内图片, 上传完成后回到输入框输入绘画提示词开始绘画</div>
                                        <input class="upload_file_input" ref="fileInput" accept="image/*" type="file" @change="inputUpload">
                                    </div>
                                    <div class="part_title">参考图预览</div>
                                    <div class="preview_part">
                                        <div style="padding-top: 7px;padding-right: 10px;" v-if="upoadLoading">
                                            正在上传，请稍后
                                            <img class="loading-pic" src="./img/loading.gif" alt="">
                                        </div>
                                        <img v-if="upload_img_url" @click="clearImg" class="clear_img" src="./img/close.png" alt="">
                                        <img class="preview_upload_img" v-if="upload_img_url" :src="upload_img_url" alt="">
                                        <div style="color: red;" v-if="uploadError">{{uploadError}}</div>
                                    </div>
                                    <div class="part_title">参考图片权重</div>
                                    <div class="slide_content">
                                        <el-slider v-model="img_iw" :marks="powerList" :min="0.5" :max="2" :step="0.1"></el-slider>
                                    </div>
                                </div>
                                <button slot="reference" :class="['footer_btn','footer_img_btn',{'active':upload_img_url}]"><img :src="require(upload_img_url?'./img/img_icon_active.png':'./img/img_icon.png')" alt="">{{upload_img_url?"参考图已添加":"添加参考图"}}</button>
                            </el-popover>
                            <div class="footer_main">
                                <div class="footer_top">
                                    <div class="footer_top_left">
                                        <div class="tool_btn" @click="appDrawerVisible=true">
                                            <img class="tool_btn_icon" src="./img/robot.png" alt="">
                                            <div class="tool_btn_text">MJ绘画提示词工具</div>
                                            <div class="btn_badge">新</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="input_wrap">
                                    <textarea class="input_area" v-model="inputVal" @keydown.enter.exact="sendMsg"  placeholder="请输入绘画提示词"></textarea>
                                    <div class="input_place">"{{inputVal}}"</div>
                                </div>
                            </div>
                            <button class="footer_btn" :disabled="!inputVal" @click="sendMsg"><img v-if="!posting" src="./img/draw_icon.png" alt=""><img v-else src="../components/img/loading.gif" alt="">绘画</button>
                            <button class="footer_btn setting_btn" @click="showSetting"><img src="./img/setting_white.png" alt="">参数设置</button>
                        </div>
                    </div>
                </div>
                <div :class="['page_right_aside',{'hide':!appDrawerVisible}]">
                    <div @click="appDrawerVisible=!appDrawerVisible" :class="['collapse_icon',appDrawerVisible?'fold':'unfold']"></div>
                    <imgappdrawer @select="exampleSelect" :visible.sync="appDrawerVisible"></imgappdrawer>
                </div>
            </div>
        </div>
        <popup ref="viewPopup" type="center" @close="popClose">
            <img class="view_img" :src="view_img_url" alt="">
            <!-- <el-image 
                :src="view_img_url" :initial-index="0"
                :preview-src-list="[view_img_url]">
            </el-image> -->
        </popup>
        <popup ref="defeatPopup" type="center" @close="defeatPopClose">
            <div class="defeat_popup">
                <div class="popup_title">失败原因如下</div>
                <div class="popup_content">
                    <div class="content_item">
                        <div class="item_question">问：为什么MidJourney绘画出图会比较慢？</div>
                        <div class="item_answer">答：因为MidJourney与其他绘画软件不同，一次性生成四张高清图片，通常仅需约5分钟完成，算下来速度相当快！</div>
                    </div>
                    <div class="content_item">
                        <div class="item_question">问：为什么绘画会提示失败？</div>
                        <div class="item_answer">答：因为MidJourney绘画全部为Ai原创，可能会出现违规低俗内容，这些图片会被系统自动过滤删除，与您无关！</div>
                    </div>
                </div>
                <button class="close_btn" @click="defeatPopClose">好的，我知道了</button>
            </div>
        </popup>
        <vipconfirm v-if="vipConfirmVisible" :from="confirmFrom" @confirm="vipConfirm"></vipconfirm>
        <vippanel v-if="showVipPopup" :from="vipFrom" :type="vipOpenType" :showPopup.sync="showVipPopup" @confirm="vipPopupConfirm"></vippanel>
        <drawsetting ref="drawSetting" :settingData.sync="settingData"></drawsetting>

   </div>
</template>
<script type="text/ecmascript-6">
    import vippanel from "COMPONENTS/VipPanel.vue"
    import vipconfirm from "COMPONENTS/VipConfirm.vue"
    import imgappdrawer from "COMPONENTS/ImgAppDrawer.vue"
    import circleloading from "COMPONENTS/CircleLoading.vue"
    import popup from "COMPONENTS/Popup.vue"
    import drawsetting from "COMPONENTS/DrawSetting.vue"
    export default {
        components:{vippanel, vipconfirm, imgappdrawer, circleloading, popup , drawsetting},
        data() {
            return {
                inputVal:"",
                score:0,
				dialog_list:[],
                currentDialog:[],
				dialogId:0,
                sending:false,
                sldeShow:true,
                showVipPopup:false,
                vipFrom:3,
                vipOpenType:3,
                vipConfirmVisible:false,
                appDrawerVisible:true,
                confirmFrom:3,
                placeholder:"体验智能Ai绘画—首选Ai",
                view_img_url:"",
                posting:false,
                recomend_img_list:[],
                settingData:{
                    artistry: 0,
                    model: 1,
                    outrageous: 0,
                    ratio: ""
                },
                upload_img_url:"",
                img_iw:1,
                powerList:{
                    0.5: '低',
                    1: '默认',
                    1.5: '中',
                    2: '高'
                },
                upoadLoading:false,
                site_skin:'',
                uploadError:''
            }
        },
        created() {
            this.site_skin = SiteSkin

            let dialogArr = localStorage.getItem("drawDialogArray");
			if(dialogArr){
				dialogArr = JSON.parse(dialogArr);
                this.dialogId = dialogArr[0].id;
			}else{
				dialogArr = [];
			}
			this.dialog_list = dialogArr;
            
            this.score = this.$store.state.userInfo.score_balance || 0;
            this.fetchDialogMsgList()
            this.fetchIndex()
            this.fetchDialogList()
        },
		watch:{
			dialog_list:{
				handler(val){
					if(val.length){
						localStorage.setItem("drawDialogArray",JSON.stringify(val))
					}else{
						localStorage.removeItem("drawDialogArray")
					}
				},
				deep: true
			}
		},
		computed:{
            userInfo(){
                return this.$store.state.userInfo;
            },
            isLogin(){
                return this.$store.state.isLogin;
            },
		},
        methods: {
            fetchIndex(){
                this.$http.get('/front/chatai/chatmj/index/').then((res) => {
					if (res.status == 200) {
                        this.recomend_img_list = res.data.item_list//.concat(res.data.item_list);
					}
				})
            },
            fetchDialogList(){
                // 获取对话列表
                this.$http.get('/front/chatai/chat/group/?ctype=mjdraw').then((res) => {
					if (res.status == 200) {
                        this.dialog_list = res.data.data_list;
					} else {
					}
				})
            },
            fetchDialogMsgList(){
                this.currentDialog = [];
                if(this.dialogId == 0) return
                // 对话内容
                this.$http.get('/front/chatai/chatmj/?group_id='+this.dialogId).then((res) => {
					if (res.status == 200) {
                        this.currentDialog = res.data.item_list;
                        this.scrollToBottom();
					} else {
                        this.$message.error(res.message)
					}
				})
            },
            checkLogin(){
                // 检查登录状态
                if(!this.isLogin){
                    this.$showLogin();
                    return false;
                }else{
                    return true;
                }
            },
            //新增对话
			addDialog(){
                if(!this.checkLogin()) return
				if(this.sending){
                    this.$toast("图片正在生成中，请稍等...")
				}else{
                    this.dialogId = 0
                    this.postAddDialog("新的绘画");
				}
			},
            postAddDialog(title,callback){
                let data = {
                    title: title,
                    editFlag: false,
                    ctype:'mjdraw',
                    id:this.dialogId||0
                }
                this.$http.post('/front/chatai/chat/group/', data).then((res) => {
                    if (res.status == 200) {
					    this.dialogId = res.data.id;
                        //给新增的聊天添加id
                        data.id=res.data.id
                        this.dialog_list.unshift(data)
                        this.currentDialog = [];
                        if(callback) callback(res.data.id);
                    } else {
                        this.$message.error(res.message)
                    }
                })
            },
			delDialog(dia, index){
                if(!this.checkLogin()) return
                this.$confirm('确定要删除吗？', '提示', {
                    type: 'warning'
                }).then(() => {
                    if(dia.id == this.dialogId){
                        this.dialog_list.splice(index,1);
                        this.dialogId = this.dialog_list.length ? this.dialog_list[0].id : 0;
                        this.fetchDialogMsgList();
                    }else{
                        this.dialog_list.splice(index,1);
                    }
                    this.$http.delete(`/front/chatai/chat/group/${dia.id}/`).then((res) => {
                    	if (res.status == 200) {
                            
                    	} else {
                            this.$message.error(res.message)
                    	}
                    })
                })
			},
            editDialog(dia, index){
                if(!this.checkLogin()) return
                dia.editFlag=true;
                this.$nextTick(()=>{
                    this.$refs['titleInput'+index][0].focus();
                })
            },
            saveDialog(dia){
                if(!this.checkLogin()) return
                dia.editFlag=false;
                this.$http.put(`/front/chatai/chat/group/${dia.id}/`, dia).then((res) => {
					if (res.status == 200) {
                        
					} else {
                        this.$message.error(res.message)
					}
				})
            },
			clearDialog(){
                if(!this.checkLogin()) return
                this.$confirm('确定要清除所有会话吗？', '提示', {
                    type: 'warning'
                }).then(() => {
                    this.dialog_list = [];
                    this.dialogId = 0;
					this.currentDialog = [];
                    this.$http.delete(`/front/chatai/chat/group/?ctype=mjdraw`).then((res) => {
                    	if (res.status == 200) {
                            
                    	} else {
                            this.$toast(res.message)
                    	}
                    })
                })
			},
            //选择对话框
			selectDialog(id){
                if(!this.checkLogin()) return
				if(this.sending){
                    this.$toast("图片正在生成中，请稍等...")
				}else{
					this.dialogId = id;
                    this.fetchDialogMsgList();
				}
			},
			randomArray(arr){
				let len = arr.length;
				if(len <= 9){
					return arr
				}else{
					let arrNew = [];
					while(arrNew.length < 9){
						let _num = Math.floor(Math.random()*len)
						let ex = arr[_num];
						if(arrNew.length == 0){
							arrNew.push(ex);
						}else{
							let flag = arrNew.some(item=>item.id==ex.id);
							if(!flag) arrNew.push(ex)
						}
					}
					return arrNew;
				}
			},
            showSetting(){
                this.$refs.drawSetting.show();
            },
            exampleSelect(data){
                this.inputVal = data.prompt;
            },
            //发送消息
			sendMsg(){
                if(!this.checkLogin()||this.posting) return
                this.inputVal = this.inputVal.trim();
                localStorage.setItem("inputVal", this.inputVal);
                event.preventDefault();
				
				if(!this.inputVal){
                    this.$toast('请输入内容')
					return
				}
                
				if(this.sending){
                    this.$toast('请等待上次绘图完成')
					return
				}
                let params = ``
                if(this.settingData.ratio){
                    params = ` --ar ${this.settingData.ratio}`
                }
                if(this.settingData.outrageous){
                    params += ` --chaos ${this.settingData.outrageous}`
                }
                if(this.settingData.artistry){
                    params += ` --s ${this.settingData.artistry}`
                }
                this.posting = true;
				let list = this.dialog_list;
				if(list.length == 0){
					this.postAddDialog(this.inputVal,(id)=>{
                        this.submitQuestion({
                            question: this.inputVal,
                            group_id:id
                        });
                    });
                    return
				}else if(!this.currentDialog.length){
                    for(let i = 0; i < list.length; i++){
                        if(list[i].id == this.dialogId){
                            list[i].title = this.inputVal;
                            let dia = list[i]
                            this.$http.put(`/front/chatai/chat/group/${dia.id}/`, dia).then((res) => {})
                            break;
                        }
                    }
				}
				// 同步请求
				this.submitQuestion({
					question: this.inputVal,
                    group_id:this.dialogId,
                    parameters:params,
                    iw_url:this.upload_img_url,
                    iw:this.img_iw
                }); 
			},
			submitQuestion(data,parent_msg_code,i){
                this.sending = true;
				// 提交问题
                data.source = SiteSource;
                this.$http.post('/front/chatai/chatmj/',data).then((res) => {
					if(res.status == 200){
						this.score = res.data.score;
                        this.sending = false;
						if(this.score == 0){
							this.sending = false;
                            this.vipConfirmVisible = true;
						}else{
				            this.inputVal = "";
                            this.currentDialog.push(res.data.draw);
					        this.scrollToBottom();
							// 发送消息
							this.fetchMsg(res.data.draw.draw_id,parent_msg_code,i);
						}
					}else{
						this.sending = false;
                        let message = res.message;
                        if(message.indexOf("您提问的内容包含违禁词")> -1){
                            message = "内容可能违反国家政策，请重新输入";
                        }
                        this.$confirm(message, '提示', {
                            type: 'warning'
                        }).then(() => {
                        })
                        // this.$message.error(message);
					}
				}).finally(()=>{this.posting = false;})
			},
			fetchMsg(id,parent_msg_code,i) {
                let timer = 'timer'+id;
				this[timer] = setInterval(()=>{
                    this.$http.get('/front/chatai/chatmj/'+id+'/').then((res) => {
                        if(res.status == 200){
                            let msg = this.currentDialog.filter((dia)=>dia.draw_id==id)[0];
                            if(!msg.img_url&&res.data.img_url){
                                this.scrollToBottom();
                            }
                            if(!msg){
                                clearInterval(this[timer]);
                                this.sending = false;
                                return
                            }
                            msg.img_url = res.data.img_url;
                            if(res.data.status<2){
                                msg.progress = res.data.progress;
                            }
                            
                            if(res.data.status==2&&res.data.local_img_url!=""){
                                msg.img_url = res.data.local_img_url
                                msg.raw_img_url = res.data.raw_img_url
                                let timeoutimer = setTimeout(()=>{
                                    msg.status = res.data.status;
                                    clearTimeout(timeoutimer);
                                },300)
                                clearInterval(this[timer]);
                                this.sending = false;
                                this.scrollToBottom();
                                if(parent_msg_code){
                                    parent_msg_code[i]=1;
                                }
                            }else if(res.data.status==3){
                                // 绘画失败
                            }
                        }else{
                            clearInterval(this[timer]);
                            this.$message.error(res.message);
                        }
                    }).catch((res)=>{
                        clearInterval(this[timer]);
                        this.$message.error(res.message);
                    })
                },2000)
			},
            detailImgRedraw(item){
                // 重新绘画
                this.inputVal = item.prompt
                this.sendMsg()
            },
            detailImg(type,i,msg,status){
                if(status!=0) return
                msg[type+'_code'][i] = 2;
                // msg.img_index = i + 1
                let data = {
                    parent_draw_id:msg.draw_id,
                    img_type:"img_"+type,
                    img_index:i+1,
                    group_id:this.dialogId
                }
                this.submitQuestion(data,msg[type+'_code'],i);
            },
            //确认去开通，显示开通弹窗
            vipConfirm(res){
                this.vipConfirmVisible = false
                if(res){
                    this.showVipPopup = true;
                }
            },
            vipPopupConfirm(){
                let invite_code = localStorage.getItem("invite_code")||"";
                this.$http.get('/front/my/profile/?invite_code='+ invite_code+'&app_id='+APP_ID).then(res =>{
                    if(res.status=='200'){
						this.$store.commit("setUserInfo",res.data);
                    }else{
                        this.$message.error(res.message)
                    }
                })
            },
            previewImg(url){
                this.view_img_url = url;
                this.$refs.viewPopup.show();
            },
            delMsg(id,index){
                this.$confirm('确定要删除吗？', '提示', {
                    type: 'warning'
                }).then(() => {
                    if(this['timer'+id]) clearInterval(this['timer'+id]);
                    this.$http.delete(`/front/chatai/chatmj/${id}/`).then((res) => {
                        if(res.status == 200){
                            this.currentDialog.splice(index,1);
                        }else{
                            this.$message.error(res.message);
                        }
                    })
                })
            },
            showDefeatPopup(){
                this.$refs.defeatPopup.show();
            },
            defeatPopClose(){
                this.$refs.defeatPopup.close();
            },
            hidePopover(){
                return false
            },
            inputUpload(e){
                
                let files = e.target.files;
                if(files.length > 1){
                    this.$message({
                        message: '仅支持单个文件上传',
                        type: 'warning'
                    })
                    return
                }
                let file = files[0];
                if(file.type != "image/jpeg" && file.type != "image/png"){
                    this.$message({
                        message: '仅支持JPG、PNG格式图片',
                        type: 'warning'
                    })
                    return
                }
                if(file.size > 10*1024*1024){
                    this.$message({
                        message: '请上传10M以内的图片',
                        type: 'warning'
                    })
                    return
                }
                // this.upload_img_url = URL.createObjectURL(file);
                this.$refs.fileInput.value = "";

                this.uploadFile(file)
            },
            async uploadFile(file){
                this.upoadLoading = true
                this.uploadError = ""
                let post_url = await this.$http.get(`${FILE_API_SERVER}/api/front/upload/?file_folder=mj_iw`).then(res => {
                    return res.data
                }).catch(e => {
                    return ""
                });
                if (!post_url) {
                }
                // 上传图片
                let formData = new FormData();
                formData.append("file", file, file.name);
                let fileResponse = await this.$http.post(post_url, formData, {
                    headers: { "Content-Type": "multipart/form-data" },
                    responseType: "text"
                }).then(res => {
                    return eval(res);
                }).catch(e => {
                    return "";
                });
                this.uploadError = fileResponse.data.error
                this.upoadLoading = false
                let iw_url = fileResponse.data.file_full_url
                this.upload_img_url = iw_url
                // if(error){
                //     this.$message({
                //         message: error,
                //         type: 'warning'
                //     })
                // }
            },
            clearImg(){
                this.upload_img_url = "";
                this.img_iw = ""
            },
            popClose(){
                this.$refs.viewPopup.close();
            },
            copytext (text) {
                const el = document.createElement('textarea')
                el.setAttribute('readonly', 'readonly')
                el.style.position = 'absolute'
                el.style.left = '-9999px'
                el.value = text
                document.body.appendChild(el)
                el.select()
                document.execCommand('copy')
                document.body.removeChild(el)
                this.$toast("复制成功");
            },
            scrollToBottom(){
                this.$nextTick(()=>{
                    let scrollWrap = this.$refs.scrollWrap;
                    scrollWrap.scrollTop = scrollWrap.scrollHeight;
                })
            },
        },
    };
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    .page_container{
        display: flex;
        width: 100%;
        height: 100%;
        min-width: 1200px;
        min-height: 600px;
        background-color: #fff;
        overflow: hidden;
        flex-direction: column;
        .page_header{
            height: 60px;
            background-color: #dbefe4;
            flex-grow: 0;
            flex-shrink: 0;
            padding: 0 16px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            box-shadow: 0 4px 6px -1px #cecece,0 2px 4px -2px #cecece;
            .header_left{
                display: flex;
                align-items: center;
                .header_logo{
                    // width: 120px;
                    height: 45px;
                    margin-right: 20px;
                }
            }
            .fold{
                background-image: url("./img/menu_fold.png");
            }
            .unfold{
                background-image: url("./img/menu_unfold.png");
            }
        }
        .page_body_wrapper{
            flex-grow: 1;
            overflow: hidden;
            padding: 16px;
            .page_body{
                height: 100%;
                overflow: hidden;
                display: flex;
                box-shadow: 0 4px 6px -1px #ccc,0 2px 4px -2px #ccc;
                border: 1px solid #e5e7eb;
                border-radius: 6px;
                .page_aside{
                    width: 260px;
                    flex-shrink: 0;
                    border-right: 1px solid #e5e7eb;
                    transition: width 0.3s;
                    position: relative;
                    &.hide{
                        width: 0;
                    }
                    .collapse_icon{
                        position: absolute;
                        top: 50%;
                        margin-top: -12px;
                        right: -12px;
                        width: 24px;
                        height: 24px;
                        background-color: #fff;
                        border-radius: 50%;
                        border: 1px solid #e5e7eb;
                        box-shadow: 0 0 4px 2px #eee;
                        cursor: pointer;
                        &::after{
                            content: "";
                            width: 7px;
                            height: 7px;
                            border: 1px solid #666;
                            border-top: none;
                            border-right: none;
                            position: absolute;
                            top: 7px;
                            transform-origin: center center;
                        }
                        &.fold::after{
                            transform: rotate(45deg);
                            left: 8px;
                        }
                        &.unfold::after{
                            transform: rotate(225deg);
                            left: 7px;
                        }
                    }
                    .aside_wrap{
                        height: 100%;
                        padding: 16px 0;
                        display: flex;
                        flex-direction: column;
                        &.overhiden{
                            overflow: hidden;
                        }
                        .slide-top{
                            flex-grow: 0;
                            flex-shrink: 0;
                            cursor: pointer;
                            border-radius: 5px;
                            border: 1px dashed #379a63;
                            height: 46px;
                            padding: 12px 0;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            color: #379a63;
                            font-size: 13px;
                            user-select: none;
                            overflow: hidden;
                            margin: 0 16px;
                            white-space: nowrap;
                        }
                        .slide-list{
                            flex-grow: 1;
                            overflow: hidden;
                            padding: 12px 0;
                            height: 0;
                            .dialog-list{
                                overflow-y: scroll;
                                margin-right: -17px;
                                height: 100%;
                                padding: 0 16px;
                                .dialog-item{
                                    margin-bottom: 10px;
                                    display: flex;
                                    align-items: center;
                                    padding: 13px;
                                    border-radius: 5px;
                                    overflow: hidden;
                                    border: 1px solid #e5e7eb;
                                    cursor: pointer;
                                    &:hover{
                                        box-shadow: 0 0 3px 0px #acedc9;
                                        border-color: #acedc9;
                                    }
                                    &.active{
                                        border-color: #379a63;
                                        color: #379a63;
                                        .dialog-msg-icon{
                                            background-image: url("./img/mj_icon_active.png");
                                        }
                                        .dialog-del-icon{
                                            background-image: url("./img/delete_icon_active.png");
                                        }
                                    }
                                    .dialog-icon{
                                        width: 20px;
                                        height: 20px;
                                        flex-shrink: 0;
                                    }
                                    .dialog-msg-icon{
                                        margin-bottom: -2px;
                                        background-image: url("./img/mj_icon.png");
                                    }
                                    .dialog-msg-text{
                                        font-size: 13px;
                                        margin-left: 6px;
                                        overflow: hidden;
                                        white-space: nowrap;
                                        text-overflow: ellipsis;
                                        flex-grow: 1;
                                        .dialog-msg-input{
                                            width: 100%;
                                            height: 20px;
                                            border: 1px solid #e5e7eb;
                                            border-radius: 3px;
                                            padding: 0 8px;
                                            font-size: 12px;
                                        }
                                    }
                                    .dialog-del-icon{
                                        margin-left: 8px;
                                        background-image: url("./img/delete_icon.png");
                                    }
                                    .dialog-edit-icon{
                                        margin-left: 8px;
                                        background-image: url("./img/edit.png");
                                    }
                                }
                            }
                            .empty-dialog{
                                padding-top: 32px;
                                .empty-icon{
                                    width: 30px;
                                    height: 30px;
                                    margin: 0 auto;
                                    background-image: url("./img/dialog_empty.png");
                                }
                                .empty-text{
                                    font-size: 12px;
                                    color: #ccc;
                                    line-height: 40px;
                                    text-align: center;
                                }
                            }
                        }
                        .slide-bottom{
                            flex-grow: 0;
                            flex-shrink: 0;
                            padding: 0 16px;
                            .slide-btn{
                                height: 46px;
                                display: flex;
                                align-items: center;
                                padding-left: 24px;
                                background-color: #dbefe4;
                                margin-bottom: 12px;
                                cursor: pointer;
                                border-radius: 5px;
                                position: relative;
                                white-space: nowrap;
                                &:last-child{
                                    margin-bottom: 0;
                                }
                                .slide-btn-icon{
                                    width: 16px;
                                    height: 16px;
                                }
                                .slide-btn-text{
                                    color: #379a63;
                                    font-size: 14px;
                                    margin-left: 9px;
                                }
                            }
                        }
                    }
                }
                .black{
                   
                   .collapse_icon{
                       position: absolute;
                       top: 50%;
                       margin-top: -12px;
                       right: -12px;
                       width: 24px;
                       height: 24px;
                       background-color: #fff;
                       border-radius: 50%;
                       border: 1px solid #e5e7eb;
                       box-shadow: 0 0 4px 2px #eee;
                       cursor: pointer;
                       &::after{
                           content: "";
                           width: 7px;
                           height: 7px;
                           border: 1px solid #666;
                           border-top: none;
                           border-right: none;
                           position: absolute;
                           top: 7px;
                           transform-origin: center center;
                       }
                       &.fold::after{
                           transform: rotate(45deg);
                           left: 8px;
                       }
                       &.unfold::after{
                           transform: rotate(225deg);
                           left: 7px;
                       }
                   }
                   .aside_wrap{
                       .slide-top{
                           border: 1px dashed #ccc;
                           color: #333;
                       }
                       .slide-list{
                           .dialog-list{
                               .dialog-item{
                                   border: 1px solid #e5e7eb;
                                   background-color: #f5f5f5;
                                   color: #333;
                                   &:hover{
                                       box-shadow: 0 0 3px 0px #ccc;
                                       border-color: #ccc;
                                   }
                                   &.active{
                                       background-color: #fff;
                                       border-color: #ccc;
                                       color: #333;
                                       .dialog-msg-icon{
                                           background-image: url("./img/mj_icon.png");
                                       }
                                       .dialog-del-icon{
                                           background-image: url("./img/delete_icon.png");
                                       }
                                   }
                                   .dialog-edit-icon{
                                        margin-left: 8px;
                                        background-image: url("/static/skin/black/edit.png");
                                    }
                               }
                           }
                           .empty-dialog{
                               .empty-icon{
                                   width: 30px;
                                   height: 30px;
                                   margin: 0 auto;
                                   background-image: url("./img/dialog_empty.png");
                               }
                               .empty-text{
                                   font-size: 12px;
                                   color: #ccc;
                                   line-height: 40px;
                                   text-align: center;
                               }
                           }
                       }
                       .slide-bottom{
                           .slide-btn{
                               background-color: #eee;
                               .slide-btn-text{
                                   color: #333;
                               }
                           }
                       }
                   }
               }
                .page_content{
                    flex-grow: 1;
                    display: flex;
                    flex-direction: column;
                    transition: width 0.3s;
                    overflow: hidden;
                    .content_body{
                        flex-grow: 1;
                        overflow-y: scroll;
                        padding: 15px;
                        margin-right: -17px;
                        .show_banner{
                            .banner_title{
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                color: #333;
                                font-size: 26px;
                                font-weight: 700;
                                line-height: 108px;
                                padding-top: 20px;
                            }
                            .banner_tips{
                                font-size: 13px;
                                color: #999;
                                line-height: 35px;
                                margin-bottom: 18px;
                                text-align: center;
                            }
                            .banner_content{
                                max-width: 850px;
                                margin: 0 auto;
                                .recommend_label{
                                    display: flex;
                                    height: 35px;
                                    align-items: center;
                                    font-size: 15px;
                                    margin-bottom: 10px;
                                    padding: 0 30px;
                                    .label_text{
                                        flex-shrink: 0;
                                        white-space: nowrap;
                                        font-weight: bold;
                                    }
                                    .label_line{
                                        flex-grow: 1;
                                        border-bottom: 1px dotted #999;
                                        margin: 0 12px;
                                    }
                                    .label_btn{
                                        cursor: pointer;
                                        display: flex;
                                        align-items: center;
                                        color: #999;
                                        line-height: 18px;
                                        img{
                                            margin-right: 6px;
                                        }
                                    }
                                }
                                .banner_img_list{
                                    display: flex;
                                    flex-wrap: wrap;
                                    justify-content: space-between;
                                    padding-top: 5vh;
                                    color: #666;
                                    padding: 0 15px;
                                    .cell_item{
                                        flex-grow: 1;
                                        width: 33.3%;
                                        margin-bottom: 30px;
                                        padding: 0 15px;
                                        .cell_content{
                                            position: relative;
                                            overflow: hidden;
                                            cursor: pointer;
                                            padding-top: 100%;
                                            &:hover{
                                                .img_info{
                                                    bottom: 0;
                                                }
                                            }
                                            .cell_img{
                                                position: absolute;
                                                top: 50%;
                                                display: block;
                                                width: 100%;
                                                height: 100%;
                                                object-fit: cover;
                                                left: 50%;
                                                transform: translate(-50%, -50%);
                                            }
                                            .img_info{
                                                position: absolute;
                                                width: 100%;
                                                left: 0;
                                                bottom: -30px;
                                                height: 30px;
                                                background-color: rgba(0,0,0,0.6);
                                                display: flex;
                                                align-items: center;
                                                justify-content: space-between;
                                                color: #fff;
                                                padding: 0 8px;
                                                transition: bottom 0.3s;
                                                .info_item{
                                                    .info_icon{
                                                        width: 12px;
                                                        height: 12px;
                                                        vertical-align: middle;
                                                        margin-right: 5px;
                                                        opacity: 1;
                                                    }
                                                    span{
                                                        vertical-align: middle;
                                                        display: inline-block;
                                                        font-size: 12px;
                                                        color: #fff;
                                                        &.tips{
                                                            color: #18a058;
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        .msg-wrap{
                            padding: 12px 32px;
                            .msg-content{
                                display: flex;
                                margin-bottom: 20px;
                                &.right{
                                    flex-direction: row-reverse;
                                    .user-img{
                                        border: none;
                                    }
                                    .content-item{
                                        margin-right: 10px;
                                        justify-content: flex-end;
                                        .msg-text{
                                            background-color: #dbefe4;
                                            padding: 8px 10px;
                                            // text-align: right;
                                            &::before{
                                                border-left-color: #dbefe4!important;
                                                right: -12px;
                                            }
                                            &::before{
                                                top: 8px;
                                            }
                                        }
                                        .msg-userinfo{
                                            margin-right: 10px;
                                            justify-content: flex-end;
                                            text-align: right;
                                            color: #333;
                                            font-size: 14px;
                                            font-weight: bold;
                                            line-height: 24px;
                                            span{
                                                font-size: 12px;
                                                line-height: 16px;
                                                color: #999;
                                                font-weight: normal;
                                                padding-right: 10px;
                                            }
                                        }
                                        
                                    }
                                }
                                &.left{
                                    .user-img{
                                        border: 1px solid #ccc;
                                    }
                                    .content-item{
                                        margin-left: 10px;
                                        flex-direction: row-reverse;
                                        .msg-text{
                                            background-color: #f5f6fb;
                                            &::before{
                                                border-right-color: #f5f6fb!important;
                                                left: -12px;
                                            }
                                        }
                                        .msg-userinfo2{
                                            margin-left: 10px;
                                            // justify-content: flex-end;
                                            color: #333;
                                            font-size: 14px;
                                            font-weight: bold;
                                            line-height: 24px;
                                            span{
                                                font-size: 12px;
                                                line-height: 16px;
                                                color: #999;
                                                padding-left: 10px;
                                                font-weight: normal
                                            }
                                        }
                                    }
                                }
                                .user-img {
                                    width: 35px;
                                    height: 35px;
                                    border-radius: 50%;
                                    flex-shrink: 0;
                                }
                                .content-item{
                                    border-radius: 10px;
                                    position: relative;
                                    display: flex;
                                    .copy-item{
                                        position: relative;
                                        width: 30px;
                                        height: 30px;
                                        flex-shrink: 0;
                                        background-color: #dbefe4;
                                        border-radius: 15px;
                                        margin-top: 3px;
                                        cursor: pointer;
                                        align-self: flex-end;
                                        margin-right: 10px;
                                        .copy-icon {
                                            width: 14px;
                                            height: 14px;
                                            position: absolute;
                                            right: 8px;
                                            bottom: 8px;
                                        }
                                    }
                                    .msg-text{
                                        border-radius: 10px;
                                        font-size: 13px;
                                        padding: 10px 15px 15px;
                                        line-height: 20px;
                                        white-space: pre-line;
                                        position: relative;
                                        &::before{
                                            content: "";
                                            display: block;
                                            position: absolute;
                                            border: 6px solid transparent;
                                            top: 12px;
                                        }
                                        &:hover{
                                           .remove_icon{
                                                display: block;
                                            }
                                        }
                                        .remove_icon{
                                            display: none;
                                            position: absolute;
                                            top: 10px;
                                            right: 10px;
                                            width: 20px;
                                            height: 20px;
                                            background-size: 100% 100%;
                                            background-position: center;
                                            background-repeat: no-repeat;
                                            background-image: url("../components/img/update_close.png");
                                            background-color: rgba(100,100,100,0.6);
                                            cursor: pointer;
                                            border-radius: 3px;
                                        }
                                        .item_prompt{
                                            font-size: 14px;
                                            line-height: 24px;
                                            // font-weight: bold;
                                            padding-right: 20px;
                                        }
                                        .item_add_time{
                                            font-size: 12px;
                                            line-height: 16px;
                                            color: #999;
                                        }
                                        .msg-item-content{
                                            font-size: 13px;
                                            line-height: 20px;
                                            padding-top: 5px;
                                            &.detail_loading{
                                                
                                                .remove_icon{
                                                    // display: none;
                                                    position: absolute;
                                                    top: 10px;
                                                    right: 10px;
                                                    width: 20px;
                                                    height: 20px;
                                                    background-size: 100% 100%;
                                                    background-position: center;
                                                    background-repeat: no-repeat;
                                                    background-image: url("../components/img/update_close.png");
                                                    background-color: rgba(100,100,100,0.6);
                                                    cursor: pointer;
                                                    border-radius: 3px;
                                                }
                                                .loading_text{
                                                    padding-left: 12px;
                                                }
                                            }
                                            .msg_img_wrap{
                                                width: 360px;
                                                position: relative;
                                                overflow: hidden;
                                                border-radius:5px;
                                                &:hover{
                                                    .img_footer{
                                                        bottom: 0;
                                                    }
                                                }
                                                .msg_img_ele{
                                                    display: block;
                                                    width: 100%;
                                                    cursor: pointer;
                                                }
                                                .img_footer{
                                                    position: absolute;
                                                    width: 100%;
                                                    left: 0;
                                                    bottom: -40px;
                                                    height: 40px;
                                                    background-color: rgba(0,0,0,0.6);
                                                    display: flex;
                                                    align-items: center;
                                                    justify-content: space-around;
                                                    transition: bottom 0.3s;
                                                    .footer_item{
                                                        cursor: pointer;
                                                        .footer_icon{
                                                            display: inline-block;
                                                            width: 14px;
                                                            height: 14px;
                                                            vertical-align: middle;
                                                            margin-right: 5px;
                                                            background-size: 100% 100%;
                                                            &.download{
                                                                background-image: url("./img/download.png");
                                                            }
                                                            &.preview{
                                                                background-image: url("./img/preview_img.png");
                                                            }
                                                            &.delete{
                                                                background-image: url("./img/remove.png");
                                                            }
                                                        }
                                                        span{
                                                            vertical-align: middle;
                                                            display: inline-block;
                                                            font-size: 14px;
                                                            color: #fff;
                                                        }
                                                    }
                                                }
                                            }
                                            .creating_progress{
                                                margin-top: 15px;
                                                display: flex;
                                                align-items: center;
                                                width: 360px;
                                                .progress_bar{
                                                    flex-grow: 1;
                                                    height: 10px;
                                                    border-radius: 5px;
                                                    background-color: #dbefe4;
                                                    margin-right: 6px;
                                                    .progress_line{
                                                        height: 100%;
                                                        background-color: #36ad6a;
                                                        border-radius: 5px;
                                                        transition: width 0.3s linear;
                                                    }
                                                }
                                                .progress_percent{
                                                    font-size: 12px;
                                                    line-height: 1;
                                                    color: #18a058;
                                                    white-space: nowrap;
                                                }
                                            }
                                            .btn_group{
                                                padding-top: 15px;
                                                display: flex;
                                                width: 360px;
                                                .redraw{
                                                    img{
                                                        height: 20px;
                                                        margin-top: 5px;
                                                    }
                                                    line-height: 32px;
                                                }
                                                .btn{
                                                    flex-grow: 1;
                                                    height: 32px;
                                                    line-height: 32px;
                                                    color: #18a058;
                                                    background-color: #dbefe4;
                                                    border-radius: 2px;
                                                    font-size: 12px;
                                                    font-weight: bold;
                                                    text-align: center;
                                                    cursor: pointer;
                                                    width: 0;
                                                    &:not(:last-child){
                                                        margin-right: 15px;
                                                    }
                                                    &.loading{
                                                        opacity: 0.6;
                                                        svg{
                                                            margin-top: -4px;
                                                            vertical-align: middle;
                                                            margin-right: 4px;
                                                            animation: rotate 2s linear infinite;
                                                        }
                                                    }
                                                    &.redraw2{
                                                        background-color:#f5f6fb;
                                                        img{
                                                            height: 30px;
                                                        }
                                                    }
                                                    &.disabled{
                                                        cursor: not-allowed;
                                                        background-color: #ddd;
                                                        color: #666;
                                                    }
                                                }
                                            }
                                        }
                                        .create_error{
                                            width: 190px;
                                            height: 190px;
                                            background-color: #fff;
                                            border-radius: 4px;
                                            padding-top: 28px;
                                            text-align: center;
                                            font-size: 14px;
                                            margin-top: 20px;
                                            .error_icon{
                                                display: block;
                                                width: 35px;
                                                margin: 0 auto;
                                            }
                                            .error_text{
                                                color: #ccc;
                                                line-height: 64px;
                                            }
                                            .error_btn{
                                                display: inline-block;
                                                cursor: pointer;
                                                color: #ffab46;
                                                padding-top: 15px;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    .content_footer{
                        padding: 16px;
                        .footer_wrap{
                            max-width: 64rem;
                            width: 100%;
                            margin: auto;
                            display: flex;
                            align-items: flex-end;
                            justify-content: space-between;
                            .footer_main{
                                margin-right: 8px;
                                flex-grow: 1;
                                .footer_top{
                                    padding-bottom: 8px;
                                    display: flex;
                                    justify-content: space-between;
                                    align-items: center;
                                    .footer_top_left{
                                        display: flex;
                                    }
                                    .tool_btn{
                                        padding: 8px 20px 8px 12px;
                                        border: 1px solid #e5e7eb;
                                        border-radius: 24px;
                                        display: flex;
                                        align-items: center;
                                        cursor: pointer;
                                        position: relative;
                                        margin-left: 24px;
                                        &:first-child{
                                            margin-left: 0;
                                        }
                                        .tool_btn_icon{
                                            width: 18px;
                                            height: 18px;
                                            display:block;
                                        }
                                        .tool_btn_text{
                                            margin-left: 4px;
                                            font-size: 14px;
                                            line-height: 1.6;
                                        }
                                        .btn_badge{
                                            background-color: #d03050;
                                            color: #FFF;
                                            position: absolute;
                                            height: 18px;
                                            line-height: 18px;
                                            border-radius: 9px;
                                            padding: 0 6px;
                                            font-size: 12px;
                                            transform: translateX(-50%);
                                            left: 100%;
                                            bottom: calc(100% - 9px);
                                            z-index: 1;
                                        }
                                    }
                                }
                                .input_wrap{
                                    position: relative;
                                    .input_area{
                                        position: absolute;
                                        top: 0;
                                        left: 0;
                                        height: 100%;
                                        width: 100%;
                                        padding: 6px 12px;
                                        word-break: break-word;
                                        display: inline-block;
                                        vertical-align: bottom;
                                        line-height: 1.7;
                                        resize: none;
                                        white-space: pre-wrap;
                                        caret-color: #18a058;
                                        border: 1px solid #e5e7eb;
                                        border-radius: 3px;
                                        &:focus{
                                            border-color: #36ad6a;
                                            box-shadow:  0 0 5px 0px #82efb2;
                                        }
                                    }
                                    .input_place{
                                        min-height: 34px;
                                        max-height: 192px;
                                        height: 100%;
                                        width: 100%;
                                        padding: 6px 12px;
                                        pointer-events: none;
                                        overflow: hidden;
                                        visibility: hidden;
                                        position: static;
                                        white-space: pre-wrap;
                                        overflow-wrap: break-word;
                                        word-break: break-word;
                                        display: inline-block;
                                        vertical-align: bottom;
                                        line-height: 1.7;
                                        resize: none;
                                        border: 1px solid #e5e7eb;
                                    }
                                }
                            }
                            .footer_btn{
                                background-color: #18a058;
                                padding: 0 14px;
                                height: 34px;
                                font-size: 14px;
                                border-radius: 3px;
                                color: #fff;
                                white-space: nowrap;
                                outline: none;
                                position: relative;
                                z-index: auto;
                                border: none;
                                display: inline-flex;
                                flex-wrap: nowrap;
                                flex-shrink: 0;
                                align-items: center;
                                justify-content: center;
                                user-select: none;
                                text-align: center;
                                cursor: pointer;
                                &.setting_btn{
                                    margin-left: 30px;
                                }
                                &:disabled{
                                    cursor: not-allowed;
                                    opacity: 0.6;
                                }
                                &.footer_img_btn{
                                    border: 1px solid #e2e4e7;
                                    color: #999;
                                    margin-right: 12px;
                                    background-color: #fff;
                                    font-size: 12px;
                                }
                                &.active{color:#18a058;}
                                img{
                                    width: 15px;
                                    margin-right: 8px;
                                }
                            }
                        }
                        .black{
                            .footer_main{
                                .input_wrap{
                                    .input_area{
                                        &:focus{
                                                border-color: #ccc;
                                                box-shadow:  0 0 5px 0px #ccc;
                                            }
                                    }
                                }
                            }
                            .footer_btn{
                                background-color: #000;
                            }
                        }
                    }
                }
                .page_right_aside{
                    width: 320px;
                    flex-shrink: 0;
                    box-shadow: 0 0 14px 4px #ccc;
                    transition: width 0.3s;
                    position: relative;
                    &.hide{
                        width: 0;
                        box-shadow: none;
                    }
                    .collapse_icon{
                        position: absolute;
                        top: 50%;
                        margin-top: -12px;
                        left: -12px;
                        width: 24px;
                        height: 24px;
                        background-color: #fff;
                        border-radius: 50%;
                        border: 1px solid #e5e7eb;
                        box-shadow: 0 0 4px 2px #eee;
                        cursor: pointer;
                        &::after{
                            content: "";
                            width: 7px;
                            height: 7px;
                            border: 1px solid #666;
                            border-top: none;
                            border-right: none;
                            position: absolute;
                            top: 7px;
                            transform-origin: center center;
                        }
                        &.fold::after{
                            transform: rotate(225deg);
                            left: 6px;
                        }
                        &.unfold::after{
                            transform: rotate(45deg);
                            left: 7px;
                        }
                    }
                }
            }
        }
        .view_img{
            display: block;
            max-width: 100%;
            max-height: 100%;
        }
    }
    .defeat_popup{
        width: 600px;
        padding: 0 30px 36px;
        background-color: #fff;
        border-radius: 10px;
        .popup_title{
            font-size: 16px;
            font-weight: bold;
            line-height: 76px;
            text-align: center;
        }
        .popup_content{
            padding-bottom: 10px;
            .content_item{
                padding-bottom: 18px;
                font-size: 13px;
                line-height: 25px;
                .item_answer{
                    color: #999;
                }
            }
        }
        .close_btn{
            width: 240px;
            height: 50px;
            border: none;
            border-radius: 5px;
            background-color: #18a058;
            color: #fff;
            font-size: 15px;
            display: block;
            margin: 0 auto;
        }
    }
	@keyframes rotate {
	    0% {
			transform: rotate(0deg);
		}
		25% {
			transform: rotate(90deg);
		}
		50% {
			transform: rotate(180deg);
		}
		75% {
			transform: rotate(270deg);
		}
		100% {
			transform: rotate(360deg);
		}
	}
    .upload_img_wrapper{

        .panel_title{
            line-height: 28px;
            font-size: 16px;
            position: relative;
            color: #333;
            .close_btn{
                position: absolute;
                width: 22px;
                height: 22px;
                background-position: center;
                background-repeat: no-repeat;
                background-image: url("./img/close.png");
                background-color: #e8e8e8;
                border-radius: 2px;
                top: 0px;
                right: 0;
                cursor: pointer;
            }
        }
        .upload_area{
            height: 140px;
            margin-top: 10px;
            padding-top: 26px;
            text-align: center;
            border-radius: 5px;
            background-color: #f2f2f2;
            position: relative;
            .upload_icon{
                border: none;
                width: 24px;
            }
            .upload_text{
                font-size: 14px;
                line-height: 32px;
                padding-top: 4px;
            }
            .upload_label{
                font-size: 12px;
                line-height: 30px;
                color: rgb(118, 124, 130);
                
            }
            .upload_file_input{
                position: absolute;
                width: 100%;
                height: 100%;
                opacity: 0;
                z-index: 1;
                top: 0;
                left: 0;
                cursor: pointer;
            }
        }
        .part_title{
            line-height: 38px;
            font-size: 12px;
            font-weight: bold;
            padding-top: 10px;
            color: #333;
        }
        .preview_part{
            height: 210px;
            padding: 16px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 5px;
            background-color: #f2f2f2;
            position: relative;
            .clear_img{
                position: absolute;
                top: 5px;
                right: 5px;
                cursor: pointer;
            }
            .preview_upload_img{
                max-width: 100%;
                max-height: 100%;
            }
        }
        .slide_content{
            padding: 0 12px;
            position: relative;
            top: -10px;
            /deep/{
                .el-slider__bar{
                    background-color: #18a058;
                }
                .el-slider__button{
                    border-color: #18a058;
                }
                .el-slider__marks-text{
                    white-space: nowrap;
                    font-size: 12px;
                    color: #333;
                }
            }
        }
    }
</style>